import { render, staticRenderFns } from "./HistoryOrders.vue?vue&type=template&id=1bad8ebd&"
import script from "./HistoryOrders.vue?vue&type=script&lang=js&"
export * from "./HistoryOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports